import React, { useEffect, useMemo } from "react";
import { FaSearch, FaMapMarkerAlt, FaFilter } from "react-icons/fa"; // NEW: imported FaFilter
import { BrandSelect, CategorySelect } from "../Selections";

const InventorySearchHeader = ({
  searchQuery,
  onSearchChange,
  selectedLocation,
  onLocationChange,
  locations,
  tradeStatus, // NEW: prop

  category, setCategory,
  brand, setBrand,

  onTradeStatusChange, // NEW: prop
}) => {
  const sortedLocations = useMemo(() => {
    const safeLocations = Array.isArray(locations) ? locations : [];
    const specific = safeLocations.filter((l) => l !== "All" && l !== "");
    return [...specific, "All"];
  }, [locations]);

  useEffect(() => {
    const safeLocations = Array.isArray(locations) ? locations : [];
    const specific = safeLocations.filter((l) => l !== "All" && l !== "");

    if (specific.length > 0 && selectedLocation === "All") {
      onLocationChange(specific[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locations]);

  return (
    <div className="mb-6 p-4 bg-white shadow-md rounded-lg border border-gray-100">
      <div className="flex flex-col md:flex-row gap-4">
        {/* Search Input */}
        <div className="flex-1">
          <label className="block text-xs font-bold text-gray-500 uppercase mb-1 ml-1">
            Search Product
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <FaSearch className="text-gray-400" />
            </div>
            <input
              type="text"
              placeholder="Search by name, code, or brand..."
              className="pl-10 p-2.5 block w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>
        </div>

        {/* Location Dropdown */}
        <div className="w-full md:w-64">
          <label className="block text-xs font-bold text-gray-500 uppercase mb-1 ml-1">
            Location
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <FaMapMarkerAlt className="text-gray-400" />
            </div>
            <select
              value={selectedLocation}
              onChange={(e) => onLocationChange(e.target.value)}
              className="pl-10 p-2.5 block w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-indigo-500 focus:border-indigo-500 cursor-pointer transition-colors"
            >
              {sortedLocations.map((loc) => (
                <option key={loc} value={loc}>
                  {loc === "All" ? "All Locations" : loc}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* NEW: Trade Status Dropdown */}
        <div className="w-full md:w-56">
          <label className="block text-xs font-bold text-gray-500 uppercase mb-1 ml-1">
            Trade Status
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <FaFilter className="text-gray-400" />
            </div>
            <select
              value={tradeStatus}
              onChange={(e) => onTradeStatusChange(e.target.value)}
              className="pl-10 p-2.5 block w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-indigo-500 focus:border-indigo-500 cursor-pointer transition-colors"
            >
              <option value="All">All Types</option>
              <option value="Trade">Trade Only</option>
              <option value="Non-Trade">Non-Trade Only</option>
            </select>
          </div>
        </div>
      </div>
      

      {/* Additional Filters */}
      <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="w-full min-w-0">
          <label className="block text-xs font-bold text-gray-500 uppercase mb-1 ml-1">
            Brand
          </label>
          <BrandSelect data={brand} setData={setBrand} isEditable={true} />
        </div>

        <div className="w-full min-w-0">
          <label className="block text-xs font-bold text-gray-500 uppercase mb-1 ml-1">
            Category
          </label>
          <CategorySelect data={category} setData={setCategory} isEditable={true} />
        </div>
      </div>

    </div>
  );
};

export default InventorySearchHeader;
